/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { NumericCellModel } from "./NumericCellModel";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { markType } from "igniteui-react-core";
import { NumericCellFormatter } from "./NumericCellFormatter";
/**
 * @hidden
 */
var NumericCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericCellPresenter, _super);
    function NumericCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(NumericCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    NumericCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.as) {
            if (a.ax(NumericCellModel.ll) || b.k2()) {
                b.ir = this.e(b);
                this.d.b9.setRawText(b.ir);
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b9, this.a);
        }
    };
    NumericCellPresenter.prototype.e = function (a) {
        if (a.lr != null) {
            var val_ = a.k5;
            var override_ = a.lr;
            return (override_.format(val_));
        }
        return NumericCellFormatter.b(a);
    };
    NumericCellPresenter.$t = markType(NumericCellPresenter, 'NumericCellPresenter', CellPresenterBase.$);
    return NumericCellPresenter;
}(CellPresenterBase));
export { NumericCellPresenter };
//# sourceMappingURL=NumericCellPresenter.js.map
